import { Controller } from 'stimulus';
import events from 'lib/events';

const pinEventsListOnce = [
  events.download_btn.initial_click,
  events.checkout.started,
  events.checkout.purchase,
];

const pinEventsListAlways = [];

export default class PinterestAnalyticsController extends Controller {
  connect() {
    this.loadPin('https://s.pinimg.com/ct/core.js');

    if (!this.isTurbolinksPreview) {
      this.pintrk('page');
    }

    this.removeListeners(pinEventsListOnce, { once: true });
    this.removeListeners(pinEventsListAlways, { once: false });

    this.registerListeners(pinEventsListOnce, { once: true });
    this.registerListeners(pinEventsListAlways, { once: false });
  }

  disconnect() {
    this.removeListeners(pinEventsListOnce, { once: true });
    this.removeListeners(pinEventsListAlways, { once: false });
  }

  registerListeners(eventsList, options) {
    eventsList.forEach((eventName) => {
      window.addEventListener(eventName, this.transformEvent, options);
    });
  }

  removeListeners(eventsList, options) {
    eventsList.forEach((eventName) => {
      window.removeEventListener(eventName, this.transformEvent, options);
    });
  }

  transformEvent = (event) => {
    // Clone the event so we don't modify the original and possibly affect other components listening for the event
    const transformedEvent = { ...event };
    transformedEvent.detail = { ...event.detail };

    switch (event.type) {
      case events.download_btn.initial_click:
        transformedEvent.detail.pinEventName = 'Download';
        break;

      case events.checkout.started:
        transformedEvent.detail.pinEventName = 'addtocart';
        transformedEvent.detail.pinEventOptions = {
          value: event.detail.transactionAmount,
          order_quantity: 1,
          currency: 'USD',
        };
        break;

      case events.checkout.purchase:
        transformedEvent.detail.pinEventName = 'checkout';
        transformedEvent.detail.pinEventOptions = {
          value: event.detail.transactionAmount,
          order_quantity: 1,
          currency: 'USD',
        };
        break;

      default:
        /* Do nothing */
    }

    if (transformedEvent.detail) {
      this.trackEvent(transformedEvent);
    }

    return true;
  }

  trackEvent = (event) => {
    if (event.detail.pinEventOptions) {
      this.pintrk('track', event.detail.pinEventName, event.detail.pinEventOptions);
    } else {
      this.pintrk('track', event.detail.pinEventName);
    }
  }

  /* eslint-disable */
  loadPin = function(e) {
    if(!window.pintrk){
      window.pintrk = function() {
        window.pintrk.queue.push(Array.prototype.slice.call(arguments))
      };
      var n=window.pintrk;n.queue=[],n.version="3.0";
      var t=document.createElement("script");
      t.async=!0,t.src=e;
      var r=document.getElementsByTagName("script")[0];
      r.parentNode.insertBefore(t,r);

      this.loadAccount();
    }
  };
  /* eslint-enable */

  loadAccount() {
    if (this.userEmail !== '') {
      this.pintrk('load', this.accountNumber, { em: this.userEmail });
    } else {
      this.pintrk('load', this.accountNumber);
    }
  }

  pintrk(...args) {
    window.pintrk(...args);
  }

  get accountNumber() {
    return '2612340750143';
  }

  get userEmail() {
    return this.element.getAttribute('data-email');
  }

  get isTurbolinksPreview() {
    return document.documentElement.hasAttribute('data-turbolinks-preview');
  }
}
